"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.validationSchema = (0, yup_1.object)().shape({
    amount: yup_rules_eth_1.bigNumberValidationSchema.min(1, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map